(() => {
  if (window.__momentumCartPackQty) return;
  window.__momentumCartPackQty = true;

  let updateTimer = null;

  /*
   * Read the package size from the Shopify variant options.
   *
   * Handles:
   *   Supply: 1 Pack
   *   Supply: 2 Pack
   *   Supply: 3 Pack
   *
   * And:
   *   1 Day + 1 Evening
   *   2 Day + 2 Evening
   *   3 Day + 3 Evening
   */
  function getPackSize(cartItem) {
    if (!cartItem) return 1;

    const optionEls = Array.from(
      cartItem.querySelectorAll('.product-option')
    );

    for (const option of optionEls) {
      const dd = option.querySelector('dd');

      let value = dd
        ? dd.textContent.trim()
        : option.textContent.trim();

      /*
       * If the theme renders:
       * Supply: 3 Pack
       * remove "Supply:"
       */
      value = value.replace(/^[^:]+:\s*/, '').trim();

      /*
       * 1 Pack
       * 2 Pack
       * 3 Pack
       */
      let match = value.match(
        /^(\d+)\s*Pack\b/i
      );

      if (match) {
        const qty = parseInt(match[1], 10);

        if (
          Number.isFinite(qty) &&
          qty > 0 &&
          qty <= 20
        ) {
          return qty;
        }
      }

      /*
       * Complete Set variants:
       *
       * 1 Day + 1 Evening
       * 2 Day + 2 Evening
       * 3 Day + 3 Evening
       */
      match = value.match(
        /^(\d+)\s*Day\s*\+\s*(\d+)\s*Evening\b/i
      );

      if (match) {
        const dayQty = parseInt(match[1], 10);
        const eveningQty = parseInt(match[2], 10);

        if (
          Number.isFinite(dayQty) &&
          dayQty === eveningQty &&
          dayQty > 0 &&
          dayQty <= 20
        ) {
          return dayQty;
        }
      }
    }

    return 1;
  }


  function getQuantityInput(cartItem) {
    if (!cartItem) return null;

    return cartItem.querySelector(
      'input.quantity__input, input[name="updates[]"]'
    );
  }


  /*
   * Dispatching "change" lets Dawn perform its normal
   * AJAX cart update.
   */
  function commitQuantity(input, quantity) {
    if (!input) return;

    input.value = String(quantity);

    input.setAttribute(
      'value',
      String(quantity)
    );

    input.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }


  /*
   * Make sure an existing cart line is valid.
   *
   * Example:
   * 3 Pack accidentally arrives in cart with quantity 2
   * -> automatically correct it to 3.
   */
  function normalizeCartItem(cartItem) {
    const packSize = getPackSize(cartItem);

    if (packSize <= 1) return;

    const input = getQuantityInput(cartItem);

    if (!input) return;

    /*
     * Also set native input attributes.
     * This helps Dawn understand the correct increments.
     */
    input.step = String(packSize);
    input.min = String(packSize);

    input.dataset.momentumPackSize =
      String(packSize);

    const current =
      parseInt(input.value, 10);

    if (!Number.isFinite(current)) return;

    /*
     * Valid examples:
     *
     * 2 Pack: 2, 4, 6, 8...
     * 3 Pack: 3, 6, 9, 12...
     */
    const isValid =
      current >= packSize &&
      current % packSize === 0;

    if (isValid) return;

    /*
     * Never reduce the customer's current quantity.
     *
     * 3-pack with qty 2 -> 3
     * 3-pack with qty 4 -> 6
     * 2-pack with qty 3 -> 4
     */
    const corrected =
      Math.max(
        packSize,
        Math.ceil(current / packSize) *
          packSize
      );

    /*
     * Prevent repeatedly correcting the same DOM state
     * while Dawn is refreshing the cart.
     */
    const correctionKey =
      current + '>' + corrected;

    if (
      input.dataset.momentumCorrection ===
      correctionKey
    ) {
      return;
    }

    input.dataset.momentumCorrection =
      correctionKey;

    setTimeout(() => {
      commitQuantity(
        input,
        corrected
      );
    }, 100);
  }


  function setupCartItems() {
    const cartItems = document.querySelectorAll(
      '.cart-item'
    );

    cartItems.forEach(normalizeCartItem);
  }


  /*
   * Intercept Dawn's +/- controls.
   *
   * Only bundle variants with pack size > 1
   * are intercepted.
   *
   * Normal 1-pack products are untouched.
   */
  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        '.quantity__button'
      );

      if (!button) return;

      const cartItem =
        button.closest('.cart-item');

      if (!cartItem) return;

      const packSize =
        getPackSize(cartItem);

      /*
       * 1-pack uses normal Dawn behavior.
       */
      if (packSize <= 1) return;

      const input =
        getQuantityInput(cartItem);

      if (!input) return;

      const current =
        parseInt(input.value, 10);

      if (!Number.isFinite(current)) {
        return;
      }

      const name =
        button.getAttribute('name');

      const isPlus =
        name === 'plus' ||
        button.classList.contains(
          'quantity__button--plus'
        );

      const isMinus =
        name === 'minus' ||
        button.classList.contains(
          'quantity__button--minus'
        );

      if (!isPlus && !isMinus) {
        return;
      }

      /*
       * Stop Dawn from also applying its normal
       * +/- 1 behavior.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      let next;

      if (isPlus) {
        next = current + packSize;
      } else {
        next = current - packSize;

        /*
         * Keep a minimum of one complete bundle.
         * Customer can use the trash icon to
         * remove the line completely.
         */
        next = Math.max(
          packSize,
          next
        );
      }

      commitQuantity(
        input,
        next
      );
    },
    true
  );


  /*
   * If somebody manually types a quantity,
   * force it onto a valid package multiple.
   */
  document.addEventListener(
    'change',
    function (event) {
      const input = event.target.closest(
        'input.quantity__input, input[name="updates[]"]'
      );

      if (!input) return;

      const cartItem =
        input.closest('.cart-item');

      if (!cartItem) return;

      const packSize =
        getPackSize(cartItem);

      if (packSize <= 1) return;

      const entered =
        parseInt(input.value, 10);

      if (!Number.isFinite(entered)) {
        return;
      }

      const valid =
        entered >= packSize &&
        entered % packSize === 0;

      if (valid) return;

      const corrected =
        Math.max(
          packSize,
          Math.ceil(
            entered / packSize
          ) * packSize
        );

      /*
       * Don't recursively trigger ourselves.
       */
      input.value =
        String(corrected);
    },
    true
  );


  /*
   * Dawn replaces cart markup after AJAX updates,
   * so re-apply bundle rules whenever the cart changes.
   */
  const observer =
    new MutationObserver(() => {
      clearTimeout(updateTimer);

      updateTimer = setTimeout(
        setupCartItems,
        80
      );
    });


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  setupCartItems();
})();